
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/atencio/[lang]",
      function () {
        return require("private-next-pages/corporatiu/atencio/[lang]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/atencio/[lang]"])
      });
    }
  